<template>
  <div
    v-if="isChannelEnabled"
    style="position: relative;z-index: 99999;"
  >
    <img
      v-if="enabledCloseBtn && !displayVerticalLauncher && (chatStatus === 'new' || chatStatus === 'close') && (screenWidth < 576) && avatarLoaded === true"
      id="closeBtnItem"
      class="sc-close-chat sc-closebtn"
      src="@/assets/img/icono-cruz.png"
      @click="hideChatbot()"
    >
    <!-- comienzo icono -->
    <div
      v-if="!isEmbedded"
      id="gbChatbot"
      class="sc-clean sc-launcher"
      :class="{opened: chatStatus === 'active', sc_launcher_not_display: displayVerticalLauncher ? true : false}"
      style="display: flex"
      @click="chatStatus === 'active' ? close() : open()"
    >
      <div
        v-if="companyName === 'nuam' || companyName === 'a2censo' || companyName === 'bvc'|| companyName === 'bsx' || companyName === 'bvl'"
        id="helpText"
        class="sc-new-icon-ayuda"
      />
      <div
        v-if="chatStatus !== 'active' && chatStatus !== 'minimize'"
        class="sc-new-icon"
        :style="{ 'background-image': 'url(' + avatar.new + ')' }"
        @mouseover="showHelpText()"
        @mouseleave="hiddenHelpText()"
        @click="hiddenHelpText()"
      >
        <div
          v-if="companyStyle === 'gatblac-new' || avatar.name === 'gatblac-new'"
          class="follow-eyes"
        />
      </div>
      <div
        v-if="chatStatus === 'active'"
        class="sc-closed-icon"
        :style="{ 'background-image': 'url(' + avatar.open + ')' }"
      />
      <div
        v-if="chatStatus === 'minimize'"
        class="sc-open-icon"
        :style="{ 'background-image': 'url(' + avatar.close + ')' }"
      >
        <div
          v-if="newMessagesCount > 0 && chatStatus === 'minimize'"
          class="sc-new-messsages-count"
        >
          {{ newMessagesCount }}
        </div>
      </div>
    </div>
    <!-- fin icono -->
    <div
      v-show="displayVerticalLauncher"
      class="sc--vertical-launcher"
      :class="displayVerticalLauncher ? '' : 'sc_not_display'"
    >
      <div
        class="sc--vertical-container"
        @click.prevent="chatStatus === 'active' ? close() : open()"
      >
        <div>
          <div
            v-show="newMessagesCount > 0 && chatStatus === 'minimize'"
            class="sc--vertical-new-messsages-count"
          >
            {{ newMessagesCount }}
          </div>
          <div
            class="sc--vertical-launcher-icon"
            :class="'sc--vli-' + chatStatus "
          />
        </div>
      </div>
    </div>
    <ChatWindow
      :class="companyStyle"
      class="sc-clean"
      :message-list="messageList"
      :on-user-input-submit="onMessageWasSent"
      :participants="participants"
      :title="chatWindowTitle"
      :subtitle="chatWindowSubTitle"
      :image-url="avatar.header"
      :chat-status="chatStatus"
      :on-close="close"
      :show-emoji="showEmoji"
      :show-file="showFile"
      :show-information="showInformation"
      :placeholder="placeholder"
      :plugin-enabled-microphone="pluginEnabledMicrophone"
      :show-typing-indicator="showTypingIndicator"
      :colors="colors"
      :always-scroll-to-bottom="alwaysScrollToBottom"
      :current-form="currentForm"
      :show-input="showInput"
      :css-style="cssStyle"
      :last-user-text="lastUserText"
      :company-name="companyName"
      :welcome-form-logo="welcomeFormLogo"
      :is-embedded="isEmbedded"
    />
  </div>
</template>
<script>
import ChatWindow from './ChatWindow.vue'
import { serverUI } from './main'

export default {
  components: {
    ChatWindow
  },
  props: {
    avatar: {
      type: Object
    },
    showEmoji: {
      type: Boolean,
      default: false
    },
    isEmbedded: {
      type: Boolean,
      required: true
    },
    chatStatus: {
      type: String,
      required: true
    },
    isChannelEnabled: {
      type: Boolean,
      required: true
    },
    open: {
      type: Function,
      required: true
    },
    close: {
      type: Function,
      required: true
    },
    showFile: {
      type: Boolean,
      default: false
    },
    showInformation: {
      type: Boolean,
      default: false
    },
    participants: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: () => ''
    },
    subtitle: {
      type: String,
      default: () => ''
    },
    titleImageUrl: {
      type: String,
      default: () => ''
    },
    onMessageWasSent: {
      type: Function,
      required: true
    },
    messageList: {
      type: Array,
      default: () => []
    },
    newMessagesCount: {
      type: Number,
      default: () => 0
    },
    placeholder: {
      type: String,
      default: '...'
    },
    pluginEnabledMicrophone: {
      type: Boolean,
      default: false
    },
    showTypingIndicator: {
      type: String,
      default: () => ''
    },
    enabledCloseBtn: {
      type: Boolean,
      default: () => false
    },
    colors: {
      type: Object,
      required: false,
      validator: c =>
        'header' in c &&
        'bg' in c.header &&
        'text' in c.header &&
        'launcher' in c &&
        'bg' in c.launcher &&
        'messageList' in c &&
        'bg' in c.messageList &&
        'sentMessage' in c &&
        'bg' in c.sentMessage &&
        'text' in c.sentMessage &&
        'receivedMessage' in c &&
        'bg' in c.receivedMessage &&
        'text' in c.receivedMessage &&
        'userInput' in c &&
        'bg' in c.userInput &&
        'text' in c.userInput,
      default: function () {
        return {
          header: {
            bg: '#4e8cff',
            text: '#ffffff'
          },
          launcher: {
            bg: '#4e8cff'
          },
          messageList: {
            bg: '#ffffff'
          },
          sentMessage: {
            bg: '#4e8cff',
            text: '#ffffff'
          },
          receivedMessage: {
            bg: '#f4f7f9',
            text: '#ffffff'
          },
          userInput: {
            bg: '#f4f7f9',
            text: '#565867'
          }
        }
      }
    },
    alwaysScrollToBottom: {
      type: Boolean,
      default: () => false
    },
    currentForm: {
      type: String,
      default: () => ''
    },
    showInput: {
      type: String
    },
    companyStyle: {
      type: String
    },
    cssStyle: {
      type: Object
    },
    lastUserText: {
      type: String,
      default: ''
    },
    companyName: {
      type: String,
      default: ''
    },
    displayVerticalLauncher: {
      type: Boolean,
      default: () => false
    },
    welcomeFormLogo: {
      type: String,
      default: ''
    }
  },
  data: () => {
    return {
      screenWidth: window.innerWidth,
      avatarLoaded: false
    }
  },
  computed: {
    chatWindowTitle () {
      if (this.title !== '') {
        return this.title
      } else {
        return ''
      }
    },
    chatWindowSubTitle () {
      if (this.subtitle !== '') {
        return this.subtitle
      } else {
        return ''
      }
    }
  },
  mounted () {
    this.onAvatarLoad()
  },
  methods: {
    hideChatbot () {
      serverUI.$emit('hideChatbot', true)
    },
    onAvatarLoad () {
      this.avatarLoaded = true
    },
    showHelpText () {
      if (document.getElementById('helpText')) {
        document.getElementById('helpText').classList.add('active')
      }
    },
    hiddenHelpText () {
      if (document.getElementById('helpText')) {
        document.getElementById('helpText').classList.remove('active')
      }
    }
  }
}
</script>
<style>
.sc-clean * {
    box-sizing: unset;
    -webkit-box-sizing: unset;
    -moz-box-sizing: unset;
    -o-box-sizing: unset;
}

.sc-clean label {
    display: inline-block;
    max-width: 100%;
    margin-bottom: 0px;
    font-weight: normal;
}

.sc--vertical-launcher {
  width: auto;
  height: 100px;
  background-color: rgb(158, 210, 235);
  padding: 0px 5px 0px 10px;
  position: fixed;
  right: 0px;
  top: 65%;
  cursor: pointer;
  border-radius: 20px 0px 0px 20px;
}

.sc--vertical-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
}

.sc--vertical-launcher-icon {
  width: 25px;
  height: 25px;
  background-size: 25px 25px;
}

.sc--vertical-new-messsages-count {
  position: absolute;
  top: 35px;
  right: 8px;
  background: #ff4646;
  color: white;
  padding: 5px;
  width: 10px;
  height: 10px;
  font-size: 10px;
  text-align: center;
  border-radius: 50%;
}

.sc--vli-new, .sc--vli-close, .sc--vli-active, .sc--vli-minimize {
    background-image: url('https://chatbotqa.gatblac.com/static/multimedia/icons/lateral-arrow.svg');
}

</style>
<style scoped>
.sc-launcher {
  width: 70px;
  height: 70px;
  background-position: center;
  background-repeat: no-repeat;
  position: fixed;
  right: 25px;
  bottom: 25px;
  border-radius: 50%;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-transition: -webkit-box-shadow 0.2s ease-in-out;
  transition: -webkit-box-shadow 0.2s ease-in-out;
  transition: box-shadow 0.2s ease-in-out;
  transition: box-shadow 0.2s ease-in-out, -webkit-box-shadow 0.2s ease-in-out;
  cursor: pointer;
}

.sc-launcher:before {
    content: "";
    position: relative;
    display: block;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    -webkit-transition: -webkit-box-shadow 0.2s ease-in-out;
    transition: -webkit-box-shadow 0.2s ease-in-out;
    transition: box-shadow 0.2s ease-in-out;
    transition: box-shadow 0.2s ease-in-out, -webkit-box-shadow 0.2s ease-in-out;
}

.sc-open-icon {
    width: 75px;
    height: 75px;
    position: fixed;
    right: 24px;
    bottom: 22px;
    transition: opacity 100ms ease-in-out, transform 100ms ease-in-out;
    background-size: 75px 75px;
}

.sc-closed-icon {
    width: 75px;
    height: 75px;
    position: fixed;
    right: 24px;
    bottom: 22px;
    transition: opacity 100ms ease-in-out, transform 100ms ease-in-out;
    background-size: 75px 75px;
}

.sc-new-icon {
    width: 178px;
    height: 73px;
    position: fixed;
    right: 24px;
    bottom: 24px;
    transition: opacity 100ms ease-in-out, transform 100ms ease-in-out;
    background-size: 178px 73px;
}

.sc-launcher.opened:before {
    box-shadow: 0px 0px 400px 250px rgba(148, 149, 150, 0.2);
}

.sc-launcher:hover {
    box-shadow: 0 0px 27px 1.5px rgba(0, 0, 0, 0.2);
}

.sc-new-messsages-count {
    position: absolute;
    top: -3px;
    left: 41px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    border-radius: 50%;
    width: 22px;
    height: 22px;
    background: #ff4646;
    color: white;
    text-align: center;
    margin: auto;
    font-size: 12px;
    font-weight: 500;
}

.sc-closebtn {
  width: 20px;
  height: 20px;
  background-position: center;
  background-repeat: no-repeat;
  position: fixed;
  right: 12px;
  bottom: 100px;
  border-radius: 50%;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-transition: -webkit-box-shadow 0.2s ease-in-out;
  transition: -webkit-box-shadow 0.2s ease-in-out;
  transition: box-shadow 0.2s ease-in-out;
  transition: box-shadow 0.2s ease-in-out, -webkit-box-shadow 0.2s ease-in-out;
  cursor: pointer;
}

.sc-close-chat {
  display: flex;
  justify-content: flex-end;
  color: black;
}

@media (min-width: 576px) {
  .sc-close-chat {
    display: none;
  }
}

@media (max-width: 450px) {
  .sc_launcher_not_display {
    display: none !important;
  }
}

@media (min-width: 451px) {
  .sc--vertical-launcher {
    display: none !important;
  }
  .sc_launcher_not_display {
    display: flex !important;
  }
}
</style>
